import React, { useState, useEffect } from "react";
import { ListGroup, Button } from "react-bootstrap";
import Axios from "axios";
import DOMPurify from "dompurify";
import HTMLParse from "html-react-parser";

//STYLES
import * as ViewerStyles from "../styles/viewer";

function Viewer(props) {
  const [posts, setPosts] = useState([]);
  const [view, setView] = useState([]);
  const [postView, setPostView] = useState(false);
  const [selectedPost, setSelectedPost] = useState({});

  useEffect(() => {
    loadBlogs();
  }, []);

  function loadBlogs() {
    const data = { uuid: props.uuid };
    Axios.post("/pods/CPOD_BLOGS_FREND/getBlogPosts", data)
      .then((res) => {
        const data = res.data;
        console.log(data);
        if (data.error == "null") {
          setPosts(data.posts);
          setView(data.view);
        }
      })
      .catch((err) => console.log(err));
  }

  function BuildPost(post) {
    if (post.images.length > 0) {
      let postText = post.content;

      for (const image of post.images) {
        postText = postText.replace(
          `{${image.id}}`,
          `<img style="max-width:100%; max-height:100%" src="/content/${image.url}" width=${image.width} height=${image.height}/>`
        );
      }
      return postText;
    } else {
      return post.content;
    }
  }

  function handleBackBtn() {
    setPostView(false);
  }

  function handleSelectedPost(uuid) {
    setSelectedPost(posts.find((post) => post.uuid == uuid));
    setPostView(true);
  }

  return (
    <div>
      {postView ? (
        <div>
          <Button
            variant="link"
            style={ViewerStyles.backBtn}
            onClick={handleBackBtn}
          >
            Back
          </Button>
          <br /> <br />
          <div style={ViewerStyles.title}>
            <strong>{selectedPost.title}</strong>
          </div>
          <br />
          {HTMLParse(DOMPurify.sanitize(BuildPost(selectedPost)))}
        </div>
      ) : (
        <div>
          {view == "display" && (
            <div>
              {posts.map((post, index) => {
                return (
                  <div key={index}>
                    <div style={ViewerStyles.title}>
                      <strong>{post.title}</strong>
                    </div>
                    <br />
                    {HTMLParse(DOMPurify.sanitize(BuildPost(post)))}
                    <br />
                  </div>
                );
              })}
            </div>
          )}
          {view == "index" && (
            <div>
              <ListGroup>
                {posts.map((post, index) => {
                  return (
                    <ListGroup.Item
                      key={index}
                      className="customCSS-blogs-indexView-item"
                      onClick={handleSelectedPost.bind(this, post.uuid)}
                    >
                      {post.title}
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Viewer;
